import { useState, useEffect, useCallback } from 'react';

export function useOtpTimer(seconds = 30) {
  const [countdown, setCountdown] = useState(seconds);
  const [active, setActive] = useState(true);

  useEffect(() => {
    if (!active) return;
    if (countdown <= 0) { setActive(false); return; }
    const t = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [countdown, active]);

  const restart = useCallback(() => {
    setCountdown(seconds);
    setActive(true);
  }, [seconds]);

  return { countdown, canResend: !active, restart };
}
